import createBreakpoints from '@material-ui/core/styles/createBreakpoints';
import {
  ADOBE_FONT_KIT_ID,
  GOOGLE_FONT_PRIMARY,
  GOOGLE_FONT_SECONDARY,
  PRIMARY_FONT_FAMILY,
  SECONDARY_FONT_FAMILY,
} from '@/utils/constants';
import { addCustomFonts } from '@/utils/fonts';

const getFonts = () => {
  // Adds Adobe fonts.
  if (ADOBE_FONT_KIT_ID) addCustomFonts({ args: ADOBE_FONT_KIT_ID, type: 'ADOBE' });
  // Adds Google fonts.
  if (GOOGLE_FONT_PRIMARY) addCustomFonts({ args: GOOGLE_FONT_PRIMARY, type: 'GOOGLE_PRIMARY' });
  if (GOOGLE_FONT_SECONDARY)
    addCustomFonts({ args: GOOGLE_FONT_SECONDARY, type: 'GOOGLE_SECONDARY' });

  return {
    primary: PRIMARY_FONT_FAMILY.replace(/;$/, ''),
    secondary: SECONDARY_FONT_FAMILY.replace(/;$/, ''),
  };
};

const breakpoints = createBreakpoints({});
const FONTS = getFonts();

const BASE: any = {
  fontStyle: 'normal',
  fontVariant: 'normal',
  letterSpacing: 'normal',
};

export const PRIMARY: any = {
  ...BASE,
  fontFamily: FONTS?.primary,
};

const SECONDARY: any = {
  ...BASE,
  fontFamily: FONTS?.secondary,
};

const typography: any = {
  fontFamily: PRIMARY.fontFamily,
  h1: {
    ...PRIMARY,
    fontWeight: 'bold',
    fontSize: '32px',
    lineHeight: 1.84,
    letterSpacing: '-0.3px',

    [breakpoints.up('md')]: {
      ...PRIMARY,
      fontSize: '60px',
      lineHeight: 0.98,
      letterSpacing: '-0.5px',
    },
  },
  h2: {
    ...SECONDARY,
    fontWeight: 'normal',
    fontSize: '36px',
    lineHeight: 1.2,

    [breakpoints.up('md')]: {
      ...SECONDARY,
      fontSize: '56px',
      lineHeight: 1.1,
    },
  },
  h3: {
    ...PRIMARY,
    fontSize: '26px',
    lineHeight: 2.27,
    fontWeight: 'bold',
    letterSpacing: '0.2px',

    [breakpoints.up('md')]: {
      ...PRIMARY,
      fontSize: '42px',
      fontWeight: 500,
      lineHeight: 1.1,
      letterSpacing: 'normal',
    },
  },
  h4: {
    ...SECONDARY,
    fontSize: '28px',
    fontWeight: 'normal',
    lineHeight: 1.21,

    [breakpoints.up('md')]: {
      ...SECONDARY,
      fontSize: '36px',
      fontWeight: 500,
      lineHeight: 1.08,
    },
  },
  h5: {
    ...PRIMARY,
    fontWeight: 'normal',
    fontSize: '18px',
    lineHeight: 1.56,
    letterSpacing: '-0.25px',

    [breakpoints.up('md')]: {
      ...PRIMARY,
      fontSize: '22px',
      lineHeight: 1.55,
      letterSpacing: '-0.31px',
    },
  },
  h6: {
    ...PRIMARY,
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: 1.56,
    letterSpacing: '-0.25px',

    [breakpoints.up('md')]: {
      ...PRIMARY,
      fontSize: '22px',
      lineHeight: 1.55,
      letterSpacing: '-0.31px',
    },
  },
  subtitle1: {
    ...PRIMARY,
    fontSize: '15px',
    fontWeight: 'normal',
    lineHeight: 2.27,
    letterSpacing: '0.2px',

    [breakpoints.up('md')]: {
      ...PRIMARY,
      fontSize: '15px',
      fontWeight: 'normal',
      lineHeight: 2.27,
      letterSpacing: '0.2px',
    },
  },
  subtitle2: {
    ...PRIMARY,
    fontSize: '15px',
    fontWeight: 500,
    lineHeight: 2.27,
    letterSpacing: '0.2px',

    [breakpoints.up('md')]: {
      ...PRIMARY,
      fontSize: '15px',
      fontWeight: 500,
      lineHeight: 2.27,
      letterSpacing: '0.2px',
    },
  },
  body1: {
    ...PRIMARY,
    fontSize: '15px',
    fontWeight: 'normal',
    lineHeight: 1.73,

    [breakpoints.up('md')]: {
      ...PRIMARY,
      fontSize: '15px',
      fontWeight: 'normal',
      lineHeight: 1.73,
    },
  },
  body2: {
    ...PRIMARY,
    fontSize: '13px',
    fontWeight: 'normal',
    lineHeight: 1.69,
    letterSpacing: '0.17px',

    [breakpoints.up('md')]: {
      ...PRIMARY,
      fontSize: '13px',
      fontWeight: 'normal',
      lineHeight: 1.69,
      letterSpacing: '0.17px',
    },
  },
  button: {
    ...PRIMARY,
    fontSize: '15px',
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.2px',
    textTransform: 'none',

    [breakpoints.up('md')]: {
      ...PRIMARY,
      fontSize: '15px',
      fontWeight: 500,
      lineHeight: '20px',
      letterSpacing: '0.2px',
      textTransform: 'none',
    },
  },
  overline: {
    ...PRIMARY,
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: 1.6,
    letterSpacing: '1px',

    [breakpoints.up('md')]: {
      ...PRIMARY,
      fontSize: '12px',
      fontWeight: 500,
      lineHeight: 1.6,
      letterSpacing: '1px',
    },
  },
  caption: {
    ...PRIMARY,
    fontSize: '12px',
    fontWeight: 'normal',
    lineHeight: 1.6,

    [breakpoints.up('md')]: {
      ...PRIMARY,
      fontSize: '12px',
      fontWeight: 'normal',
      lineHeight: 1.6,
    },
  },
  primarySup: {
    fontSize: '0.65em !important',
    fontFamily: `${FONTS?.primary} !important`,
    lineHeight: '0 !important',
    fontWeight: 'bold !important',
  },
  secondarySup: {
    fontSize: '0.45em !important',
    fontFamily: `${FONTS?.secondary} !important`,
    lineHeight: '0 !important',
    fontWeight: 'bold !important',
  },
};

export default typography;
